export const MAX_SMS_LENGTH = 640;
export const SMS_SEGMENT_LENGTH = 160;

export const SMS_KEYWORDS = [
    { key: 'PATIENT_NAME', label: 'Patient Name', group: 'Patient' },
    { key: 'PATIENT_FIRST', label: 'First Name', group: 'Patient' },
    { key: 'PATIENT_LAST', label: 'Last Name', group: 'Patient' },
    { key: 'PATIENT_PREFERRED', label: 'Preferred Name', group: 'Patient' },
    { key: 'CLINIC_NAME', label: 'Clinic Name', group: 'Clinic' },
    { key: 'CLINIC_PHONE', label: 'Clinic Phone', group: 'Clinic' },
    { key: 'CLINIC_EMAIL', label: 'Clinic Email', group: 'Clinic' },
    { key: 'CLINIC_ADDRESS', label: 'Clinic Address', group: 'Clinic' },
];

const SAMPLE_PATIENT = {
    PATIENT_NAME: 'Jane Doe',
    PATIENT_FIRST: 'Jane',
    PATIENT_LAST: 'Doe',
    PATIENT_PREFERRED: 'Jane',
    PATIENT_FIRST_NAME: 'Jane',
    PATIENT_LAST_NAME: 'Doe',
};

const formatClinicAddress = (clinicInfo) => {
    if (!clinicInfo) {
        return '123 Main St, City, Province A1A 1A1';
    }

    const parts = [
        clinicInfo.street,
        clinicInfo.city,
        [clinicInfo.province, clinicInfo.postalCode].filter(Boolean).join(' '),
    ].filter(Boolean);

    return parts.length > 0 ? parts.join(', ') : '123 Main St, City, Province A1A 1A1';
};

export const buildSmsPreviewValues = (clinicInfo) => ({
    ...SAMPLE_PATIENT,
    CLINIC_NAME: clinicInfo?.name || 'Your Clinic',
    CLINIC_PHONE: clinicInfo?.phone || '(555) 123-4567',
    CLINIC_EMAIL: clinicInfo?.email || 'info@yourclinic.com',
    CLINIC_ADDRESS: formatClinicAddress(clinicInfo),
});

export const replaceSmsKeywords = (message, values) => {
    if (!message) {
        return '';
    }

    return message.replace(/\{([A-Z0-9_]+)\}/g, (match, key) =>
        Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match
    );
};

export const getSmsSegmentCount = (length) => {
    if (!length || length <= 0) {
        return 0;
    }

    return Math.ceil(length / SMS_SEGMENT_LENGTH);
};

export const insertKeywordAtCursor = (value, keyword, selectionStart, selectionEnd) => {
    const token = `{${keyword}}`;
    const start = selectionStart ?? value.length;
    const end = selectionEnd ?? start;
    const nextValue = `${value.slice(0, start)}${token}${value.slice(end)}`;
    const nextCursor = start + token.length;

    return { nextValue, nextCursor };
};
